import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callsectionMasterGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.sectionMaster,{
      params:{
        customerSegmentIds:payload?.customerSegmentId
    }
  });
  return data;
};